export default "/wp-content/themes/moving/assets/images/hero/winter/bike.png";